import PointComponent from '@components/point';
import * as React from 'react';

export interface IPointProps {}

export default function Point(props: IPointProps) {
  return <PointComponent />;
}
